import { render, staticRenderFns } from "./simOpenXcp.vue?vue&type=template&id=6fe01fde&scoped=true&"
import script from "./simOpenXcp.vue?vue&type=script&lang=js&"
export * from "./simOpenXcp.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXcp.vue?vue&type=style&index=0&id=6fe01fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe01fde",
  null
  
)

export default component.exports